<template>
  <section
    class="block items-start mx-auto mt-4 mb-16 px-4 max-w-screen-lg md:flex text-base home-blog"
  >
    <VPage :posts="posts" />
    <section
      class="sticky top-20 mb-8 p-6 md:ml-4 flex-[0_0_300px] bg-primary/2 border-solid border-1 rounded-2 border-base home-blog__aside"
    >
      <h4
        class="flex justify-between items-center mt-4 pb-2 pt-0 home-blog__title"
      >
        <VIcon icon="i-tabler-folder" text="分类" />
        <a
          v-if="categoryList.length > 6"
          :href="`/category.html?page=1&key=${categoryList[0].label}`"
          class="text-base text-xs cursor-pointer hover:text-primary"
          >查看所有</a
        >
      </h4>

      <ul class="list-none pl-0 home-category">
        <li
          class="mb-4 rounded-lg cursor-pointer border-primary border border-solid home-category__item"
          v-for="(value, index) in categoryList.slice(0, 6)"
          :key="index"
        >
          <a
            class="flex justify-between px-4 py-1.5 home-category__link"
            :href="`/category.html?key=${value.label}&page=1`"
          >
            <span
              class="mr-1 text-xs leading-5 text-base home-category__text"
              >{{ value.label }}</span
            >
            <span
              class="inline-block h-5 px-2 bg-primary rounded-lg text-white text-xs leading-5 home-category__num"
              >{{ value.length }}</span
            >
          </a>
        </li>
      </ul>

      <h4
        class="flex justify-between items-center mt-4 pb-2 pt-0 home-blog__title"
      >
        <VIcon icon="i-tabler-tag" text="标签" />
        <a
          v-if="tagList.length > 20"
          :href="`/tag.html?page=1&key=${tagList[0]}`"
          class="text-base text-xs cursor-pointer hover:text-primary"
          >查看所有</a
        >
      </h4>

      <ul class="list-none pl-0 home-tag">
        <li
          class="inline-block mr-2 mb-2 rounded-md cursor-pointer border border-solid home-tag__item"
          v-for="(value, index) in tagList.slice(0, 20)"
          :key="index"
          :style="{ borderColor: createOneColor() }"
        >
          <a
            class="flex justify-between px-2 py-1 leading-none text-xs home-tag__link"
            :href="`/tag.html?key=${value}&page=1`"
            >{{ value }}</a
          >
        </li>
      </ul>

      <h4
        class="flex justify-between items-center mt-4 pb-2 pt-0 home-blog__title"
      >
        <VIcon icon="i-tabler-friends" text="友情链接" />
      </h4>
      <TransitionGroup
        tag="ul"
        class="h-60 overflow-hidden list-none pl-0 home-friend"
        name="list"
        @mouseenter="handleFriendLinks.stop"
        @mouseleave="handleFriendLinks.start"
      >
        <li
          class="mb-4 rounded-lg cursor-pointer border border-solid border-base hover:border-primary home-friend__item"
          v-for="(friend, index) in friendLinks"
          :key="friend.siteName"
        >
          <a
            class="flex justify-between items-center px-4 py-0.5 home-friend__link"
            :href="friend.link"
          >
            <img
              class="rounded-full w-10 h-10 home-friend__avatar"
              :src="friend.avatar"
              alt="friend.siteName"
            />
            <span
              class="inline-block h-5 px-2 rounded-lg text-base text-xs leading-5 home-friend__text"
              >{{ friend.siteName }}</span
            >
          </a>
        </li>
      </TransitionGroup>
    </section>
  </section>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { useData } from 'vitepress';
import VPage from '../VPage.vue';
import { createOneColor, sleep, throttle } from '../../utils';
import {
  useCategories,
  usePosts,
  useTags,
} from '../../composables/usePageData';
import { FriendLink } from '../../types';

const posts = usePosts();
const categories = useCategories();
const tags = useTags();

const categoryList = computed(() => {
  return Object.keys(categories).map((label) => {
    return {
      label,
      length: categories[label].length,
    };
  });
});

const tagList = computed(() => {
  return Object.keys(tags) || [];
});

const { page } = useData();
const friendLinks = ref<FriendLink[]>([]);
// page.value.frontmatter?.blog?.friendLinks

const handleFriendLinks = (function (links: FriendLink[]) {
  let index = 4
  const len = links.length
  let timer: number | null = null
  friendLinks.value = links.slice(0, 4)
  async function link() {
    if (len <= 4) return
    if (index >= len) index = 0
    friendLinks.value.shift();
    friendLinks.value.push(links.slice(index, ++index)[0]);
    if (len > 4) {
      timer && clearTimeout(timer);
      timer = window.setTimeout(() => {;
        link();
      }, 3000);
    }
  }
  return {
    async start() {
      link();
    },
    stop() {
      timer && clearTimeout(timer)
    },
  };
})(page.value.frontmatter?.blog?.friendLinks || []);

onMounted(() => {
  handleFriendLinks.start();
});

// @ts-ignore
if (!import.meta.env.SSR) {
  window.addEventListener(
    'scroll',
    throttle(() => {
      const card = document.querySelector('.home-blog__aside');

      // @ts-ignore
      card.setAttribute('data-x', card.offsetLeft);
      // @ts-ignore
      card.setAttribute('data-y', card.offsetTop);
      // @ts-ignore
      card.setAttribute('data-width', card.clientWidth);
      // @ts-ignore
      card.setAttribute('data-height', card.clientHeight);
    }, 50)
  );
}
</script>

<style lang="scss">
.home-category__item {
  &:hover {
    @apply bg-primary/90;
    .home-category__text {
      @apply text-white;
    }
    .home-category__num {
      @apply text-white;
    }
  }
}

.home-tag__item {
  &:hover {
    @apply bg-primary/90 text-white;
    .home-tag__link {
      @apply text-white;
    }
  }
}
.list-move, /* 对移动中的元素应用的过渡 */
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

/* 确保将离开的元素从布局流中删除
  以便能够正确地计算移动的动画。 */
.list-leave-active {
  position: absolute;
}
</style>
